import { render, staticRenderFns } from "./NaoAutorizado.vue?vue&type=template&id=4be09430"
import script from "./NaoAutorizado.vue?vue&type=script&lang=js"
export * from "./NaoAutorizado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports